import type { CodeScenario } from './types.js';

// Default, versioned scenario hypotheses (regles-metier, HYPOTHESES v3).
// Gross annual returns; the net rate is derived from the fee in the engine.
export const HYPOTHESES_DEFAUT = {
  version: 3,
  /** Default annual management fee (0.60%). */
  fraisGestionDefaut: 0.006,
  /** Gross annual return per scenario. */
  scenarios: {
    prudent: 0.018,
    equilibre: 0.038,
    dynamique: 0.06,
  },
} as const;

/** Ordered list of scenario codes. */
export const SCENARIOS: readonly CodeScenario[] = ['prudent', 'equilibre', 'dynamique'];

/** French display label for a scenario code. */
export const LIBELLE_SCENARIO: Readonly<Record<CodeScenario, string>> = {
  prudent: 'Prudent',
  equilibre: 'Équilibré',
  dynamique: 'Dynamique',
};
